import {
  addMonths,
  eachDayOfInterval,
  endOfMonth,
  endOfWeek,
  format,
  isSameDay,
  isSameMonth,
  startOfMonth,
  startOfWeek,
  subMonths,
} from "date-fns";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Button from "../../../../components/Button/Button";
import "../StudentWordOfTheDay.css";

const WEEKDAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

/**
 * Month grid for picking which day's Word of the Day to view. `month` is any
 * Date inside the displayed month; `selectedDate` is the day currently shown
 * on the page; `onMonthChange`/`onSelectDate` are called on nav/day click.
 */
const WordOfTheDayCalendar = ({ month, selectedDate, onMonthChange, onSelectDate }) => {
  const gridStart = startOfWeek(startOfMonth(month), { weekStartsOn: 1 });
  const gridEnd = endOfWeek(endOfMonth(month), { weekStartsOn: 1 });
  const gridDays = eachDayOfInterval({ start: gridStart, end: gridEnd });

  const goToToday = () => {
    const today = new Date();
    onMonthChange(startOfMonth(today));
    onSelectDate(today);
  };

  return (
    <div className="wotd-calendar">
      <div className="wotd-calendar-header">
        <button type="button" className="wotd-calendar-today" onClick={goToToday}>
          Today
        </button>
        <div className="wotd-calendar-nav">
          <Button
            variant="link"
            size="sm"
            icon={<ChevronLeft size={18} />}
            onClick={() => onMonthChange(subMonths(month, 1))}
            aria-label="Previous month"
          />
          <div className="wotd-calendar-title">
            <div className="wotd-calendar-month">{format(month, "MMMM")}</div>
            <div className="wotd-calendar-year">{format(month, "yyyy")}</div>
          </div>
          <Button
            variant="link"
            size="sm"
            icon={<ChevronRight size={18} />}
            onClick={() => onMonthChange(addMonths(month, 1))}
            aria-label="Next month"
          />
        </div>
      </div>

      <div className="wotd-calendar-weekdays">
        {WEEKDAYS.map((weekday) => (
          <div key={weekday} className="wotd-calendar-weekday">
            {weekday}
          </div>
        ))}
      </div>

      <div className="wotd-calendar-grid">
        {gridDays.map((day) => {
          const dateKey = format(day, "yyyy-MM-dd");
          const isToday = isSameDay(day, new Date());
          const isSelected = selectedDate && isSameDay(day, selectedDate);

          return (
            <div
              key={dateKey}
              className={`wotd-calendar-cell${isSameMonth(day, month) ? "" : " is-outside"}`}
            >
              <button
                type="button"
                className={`wotd-calendar-date${isToday ? " is-today" : ""}${isSelected ? " is-selected" : ""}`}
                onClick={() => onSelectDate(day)}
              >
                {format(day, "d")}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WordOfTheDayCalendar;
